import * as React from 'react';
import { connect } from 'react-redux';
import type { RootState } from 'src/store/app';
import { getContactEmailForUser } from '../../modules/general.utils';
import { dispatchAnalyticsEvent } from '../../modules/global.utils';
import HybridLink from './HybridLink/HybridLink';

const UpgradePlanMessage = (props: $TSFixMe) => {
    const owner = props.collaborators.find(({ role }: $TSFixMe) => role === 'owner');
    const collaboratorEmail = props.user?.email;
    const collaborator = props.collaborators.find(({ email }: $TSFixMe) => email === collaboratorEmail);
    const message = `I'm currently in "${collaborator?.role ?? 'Unknown'}" role on our Netlify Create project ${
        props.project?.name
    } and I'd love to be able to edit
 the website as well. Could you please change my role to an "Editor" or a "Publisher"? If we're not on a paid plan,
 that might require starting a free trial.
 Thank you.`;
    const link = getContactEmailForUser({
        user: props.user,
        subject: "I'd like to edit our website with Netlify Create",
        emailBody: message,
        mail: owner?.email
    });
    const handleClick = React.useCallback(() => {
        dispatchAnalyticsEvent(`Studio Upgrade Collaborator Permissions`, {
            currentRole: collaborator?.role
        });
    }, [collaborator]);

    return (
        <>
            <p>This feature is available on higher permission user roles</p>
            <br />
            <h2>
                Please{' '}
                <HybridLink to={link} onClick={handleClick}>
                    ask
                </HybridLink>{' '}
                your admin to change your role.
            </h2>
        </>
    );
};

const mapStateToProps = (state: RootState) => ({
    user: state.global.user,
    project: state.studio.project,
    collaborators: state.studio.collaborators.entries
});

export default connect(mapStateToProps)(UpgradePlanMessage);
